/**
 * ImagePreview Component
 * Displays thumbnail preview of uploaded image before sending
 */

import React from 'react';

/**
 * Format file size for display
 */
function formatFileSize(bytes) {
  if (!bytes) return '0 B';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

/**
 * X icon for remove button
 */
function XIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  );
}

function ImagePreview({ image, onRemove }) {
  if (!image) return null;

  // Create object URL for preview if we have base64
  const previewUrl = image.base64 
    ? `data:${image.mimetype || 'image/jpeg'};base64,${image.base64}`
    : image.url;

  return (
    <div className="chatbot-image-preview">
      <img 
        src={previewUrl} 
        alt="Upload preview" 
        className="chatbot-image-thumb"
      />
      <div className="chatbot-image-info">
        <div className="chatbot-image-name">{image.name || 'Image'}</div>
        <div className="chatbot-image-size">{formatFileSize(image.size)}</div>
      </div>
      <button 
        className="chatbot-image-remove" 
        onClick={onRemove}
        type="button"
        aria-label="Remove image"
      >
        <XIcon />
      </button>
    </div>
  );
}

export default ImagePreview;
